export default __webpack_public_path__ + "static/media/Doodle-logo.bda6d13c.png";